import { createApp } from 'vue'
import Resources from './Resources'
import VueProgressBar from "@aacassandra/vue3-progressbar"

const options = {
    color: "#c7932c",
    failedColor: "#874b4b",
    thickness: "5px",
    transition: {
        speed: "0.2s",
        opacity: "0.6s",
        termination: 300,
    },
    autoRevert: true,
    location: "top",
    inverse: false,
}

const mountEl = document.querySelector( "#bpa_resources" )

const app = createApp( Resources, { ...mountEl.dataset } )

app.use( VueProgressBar, options )
app.mount( '#bpa_resources' )